/**
 * BFF `data.ding_tong_banner`：按路由场景选择顶通（home / goods_list / goods_detail / cart）
 * 与 M 端 dt-wap-route 对齐，并补充 PC 路由 name 差异（如搜索结果为 search）
 */

export type DtPcSceneKey = 'home' | 'goods_list' | 'goods_detail' | 'cart';

/** 支付链路、补差价支付，全屏注册登录页等：不展示顶通 */
const HIDE_DT_ROUTE_NAMES = new Set<string>([
  'payment',
  'waitingResponse',
  'WaitingResponsePayCenter',
  'priceDifference',
  'register',
]);

/** 全屏注册 / 登录 / 找回密码相关页：不展示顶通 */
const HIDE_DT_AUTH_ROUTE_NAMES = new Set<string>(['register', 'forgotPassword', 'resetPassword']);

/**
 * 列表类页（常规列表、搜索结果、专题/新品/活动集合等）：使用 goods_list 配置
 */
const GOODS_LIST_DT_ROUTE_NAMES = new Set<string>([
  'goodsList',
  'goodsListPreview',
  'search',
  'AuroraCollection',
  'AuroraCollectionView',
  'NeonCollection',
  'NeonCollectionView',
  'BlueLightCollection',
  'BlueLightCollectionView',
  'ProgressiveCollection',
  'ProgressiveCollectionView',
  'PhotochromicCollection',
  'PhotochromicCollectionView',
  'EcoCollection',
  'EcoCollectionView',
  'TransitionsCollection',
  'TransitionsCollectionView',
  'CustomTheme',
  'CustomThemeView',
  'newEyeGlasses',
  'newEyeGlassesView',
  'CustomNewEyeGlasses',
  'CustomNewEyeGlassesView',
  'SpecialOffers',
]);

/**
 * @returns 当前路由对应的顶通场景块 key；不需要展示顶通时返回 null
 */
export function getDtPcSceneKey(routeName: string | null | undefined): DtPcSceneKey | null {
  const name = routeName || '';
  if (HIDE_DT_ROUTE_NAMES.has(name) || HIDE_DT_AUTH_ROUTE_NAMES.has(name)) {
    return null;
  }
  if (name === 'cart') {
    return 'cart';
  }
  if (name === 'goodsDetail') {
    return 'goods_detail';
  }
  if (GOODS_LIST_DT_ROUTE_NAMES.has(name)) {
    return 'goods_list';
  }
  return 'home';
}
